import { Expose } from 'class-transformer';

export class GeneratePdfPostModel {
  @Expose({ name: 'invoice_id' })
  public invoiceId = -1;
}
